module.exports = __webpack_public_path__ + "assets/img/logo.18093607.png";